
/*----------------------
       SLIDER
---------------------- */
SliderProductsList = {
    init: function () {
        if ($(".swiper-products-list .swiper-slide").length > 1) {
            var swiper = new Swiper(".swiper-products-list", {
                slidesPerView: "auto",
            });
        }
    }
};

$(document).ready(function () {
    SliderProductsList.init();
});
